export default {
    van: true,
    car: true,
    home: true,
    device: true,
    travel: true
}